import { lazy } from "react";
export const ConnectedGenericErrorPageLazy = lazy(() =>
  import("./ConnectedGenericErrorPage")
);
